import moment from 'moment';

const isToday = ({ from, to }) => {
  if (!from || !to) {
    return false;
  }
  const today = moment();
  const momentFrom = moment(from);
  const momentTo = moment(to);
  return momentFrom.isSame(today, 'day') && momentTo.isSame(today, 'day');
};

const isTomorrow = ({ from, to }) => {
  if (!from || !to) {
    return false;
  }
  const tomorrow = moment().add(1, 'day');
  const momentFrom = moment(from);
  const momentTo = moment(to);

  return momentFrom.isSame(tomorrow, 'day') && momentTo.isSame(tomorrow, 'day');
};

const isTodayAndTomorrow = ({ from, to }) => {
  if (!from || !to) {
    return false;
  }
  const today = moment();
  const tomorrow = moment().add(1, 'day');
  const momentFrom = moment(from);
  const momentTo = moment(to);
  return momentFrom.isSame(today, 'day') && momentTo.isSame(tomorrow, 'day');
};

export { isToday, isTomorrow, isTodayAndTomorrow };
